{
  "sidebar": {
    "main": {
      "home": "Home",
      "orders": "Orders",
      "tasks": "Tasks",
      "loans": "Loans",
      "catalog": "Catalog",
      "reports": "Reports",
      "communications": "Communications",
      "settings": "Settings"
    },
    "submenu": {
      "catalog": {
        "clients": "Clients",
        "vendors": "Vendors",
        "productsRules": "Products & Rules"
      },
      "reports": {
        "sla": "SLA Compliance",
        "orders": "Order Volumes & Revenue",
        "inventoryReconciliation": "Inventory Reconciliation"
      }
    }
  },
  "breadcrumbs": {
    "managePageContent": "Manage page content"
  }
}
